var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("SchemaTablePage", {
        ref: "tablePageRef",
        attrs: {
          "search-schema": _vm.searchSchema,
          columns: _vm.tableColumns,
          "default-query": _vm.defaultQuery,
          request: _vm.request,
          "build-params": _vm.buildParams,
          "parse-result": _vm.parseResult,
          "table-attrs": _vm.tableAttrs,
          "table-listeners": _vm.tableListeners,
        },
        scopedSlots: _vm._u([
          {
            key: "search-ip",
            fn: function ({ query }) {
              return [
                _c("el-input", {
                  attrs: { placeholder: "输入IP地址", clearable: "" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "prepend",
                        fn: function () {
                          return [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100px" },
                                attrs: {
                                  size: "mini",
                                  placeholder: "选择IP类型",
                                },
                                model: {
                                  value: query.ipType,
                                  callback: function ($$v) {
                                    _vm.$set(query, "ipType", $$v)
                                  },
                                  expression: "query.ipType",
                                },
                              },
                              [
                                _c("el-option", {
                                  attrs: { label: "登录IP", value: "login" },
                                }),
                                _c("el-option", {
                                  attrs: { label: "注册IP", value: "reg" },
                                }),
                              ],
                              1
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    true
                  ),
                  model: {
                    value: query.ip,
                    callback: function ($$v) {
                      _vm.$set(query, "ip", $$v)
                    },
                    expression: "query.ip",
                  },
                }),
              ]
            },
          },
          {
            key: "search-dateRange",
            fn: function ({ query }) {
              return [
                _c("DateTimeRangePicker", {
                  staticStyle: { width: "100%" },
                  attrs: { size: "mini" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "prepend",
                        fn: function () {
                          return [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100px" },
                                attrs: {
                                  size: "mini",
                                  placeholder: "选择时间类型",
                                },
                                model: {
                                  value: query.timeType,
                                  callback: function ($$v) {
                                    _vm.$set(query, "timeType", $$v)
                                  },
                                  expression: "query.timeType",
                                },
                              },
                              [
                                _c("el-option", {
                                  attrs: { label: "登录时间", value: "login" },
                                }),
                                _c("el-option", {
                                  attrs: { label: "注册时间", value: "reg" },
                                }),
                              ],
                              1
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    true
                  ),
                  model: {
                    value: query.dateRange,
                    callback: function ($$v) {
                      _vm.$set(query, "dateRange", $$v)
                    },
                    expression: "query.dateRange",
                  },
                }),
              ]
            },
          },
          {
            key: "memberAccount",
            fn: function ({ row }) {
              return [
                _c("MemberAccountCell", {
                  attrs: {
                    row: row,
                    username: row.username,
                    uid: row.uid,
                    "vip-level": row.vip_level,
                  },
                  on: { "detail-closed": _vm.handleRefreshTable },
                }),
              ]
            },
          },
          {
            key: "colPayin",
            fn: function ({ row }) {
              return [
                _vm._v(
                  " " +
                    _vm._s(_vm.formatYuan(row.total_payin_amount)) +
                    "（" +
                    _vm._s(
                      row.total_payin_times != null
                        ? row.total_payin_times
                        : "--"
                    ) +
                    "次） "
                ),
              ]
            },
          },
          {
            key: "colPayout",
            fn: function ({ row }) {
              return [
                _vm._v(
                  " " +
                    _vm._s(_vm.formatYuan(row.total_payout_amount)) +
                    "（" +
                    _vm._s(
                      row.total_payout_times != null
                        ? row.total_payout_times
                        : "--"
                    ) +
                    "次） "
                ),
              ]
            },
          },
          {
            key: "colDiff",
            fn: function ({ row }) {
              return [
                _vm._v(
                  " " +
                    _vm._s(_vm.formatYuan(row.total_payment_win_loss)) +
                    "（" +
                    _vm._s(_vm.formatYuan(row.first_payin_amount)) +
                    "） "
                ),
              ]
            },
          },
          {
            key: "colStatus",
            fn: function ({ row }) {
              return [
                _c(
                  "el-tag",
                  {
                    attrs: {
                      size: "mini",
                      type: row.status === 1 ? "success" : "danger",
                    },
                  },
                  [
                    _vm._v(
                      " " + _vm._s(row.status === 1 ? "正常" : "停用") + " "
                    ),
                  ]
                ),
              ]
            },
          },
          {
            key: "colLoginInfo",
            fn: function ({ row }) {
              return [
                _c("div", { staticClass: "login-info-cell" }, [
                  _c("div", [_vm._v(_vm._s(row.login_ip || "--"))]),
                  _c("div", [_vm._v(_vm._s(row.country || "--"))]),
                ]),
              ]
            },
          },
          {
            key: "colActions",
            fn: function ({ row }) {
              return [
                _c(
                  "div",
                  { staticClass: "action-buttons" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { size: "mini", type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.handleDetail(row)
                          },
                        },
                      },
                      [_vm._v(" 详情 ")]
                    ),
                  ],
                  1
                ),
              ]
            },
          },
        ]),
      }),
      _c("MemberDetailDialogV2", {
        attrs: {
          visible: _vm.detailDialogVisible,
          "member-uid": _vm.selectedMemberUid,
          "user-info": _vm.currentMemberInfo,
        },
        on: {
          "update:visible": function ($event) {
            _vm.detailDialogVisible = $event
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }